var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_18445_32902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8236 24.0255C50.8656 12.242 38.9156 5.08754 27.1321 8.04547C17.9236 10.3571 11.2372 18.3158 10.5483 27.7849C4.00988 28.8632 -0.416508 35.0376 0.661749 41.576C1.62027 47.3888 6.65697 51.6457 12.5481 51.6223H22.547V47.6228H12.5481C8.13031 47.6228 4.54895 44.0414 4.54895 39.6236C4.54895 35.2059 8.13031 31.6245 12.5481 31.6245C13.6526 31.6245 14.5479 30.7292 14.5479 29.6247C14.5379 19.6847 22.5878 11.6186 32.5279 11.6087C41.1324 11.6001 48.5395 17.6832 50.2039 26.1251C50.3683 26.968 51.0524 27.6119 51.9038 27.7249C57.3709 28.5035 61.1716 33.5665 60.3932 39.0336C59.6942 43.9428 55.5026 47.598 50.5439 47.6228H42.5448V51.6223H50.5439C58.2751 51.599 64.5234 45.3126 64.4999 37.5815C64.4804 31.1459 60.0754 25.5527 53.8236 24.0255Z",
    fill: "#475069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1261 32.2046L23.127 40.2037L25.9466 43.0234L30.5461 38.4439V57.6218H34.5457V38.4439L39.1252 43.0234L41.9449 40.2037L33.9458 32.2046C33.1657 31.4292 31.9061 31.4292 31.1261 32.2046Z",
    fill: "#475069"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18445_32902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.4b9f803987b78fa87da9144d1ebdc2bf.svg";
export { ForwardRef as ReactComponent };